import { cookie } from './cookie';

export interface AffiliateCookieData {
  AffiliateId?: string;
  ClientId?: string;
  utm_medium?: string;
}

enum AffilliateCookieProperties {
  AffiliateId = 'AffiliateId',
  ClientId = 'ClientId',
  // UTM MEDIUM needs to written with lowcase
  UtmMedium = 'utm_medium',
}

enum Cookies {
  AffiliateCookie = 'AffiliateCookie',
}

export function getAffiliateCookieData():
  | {
      affiliateCookie: string;
      affiliateCookieParams: AffiliateCookieData;
    }
  | undefined {
  const affiliateCookie = cookie.get(Cookies.AffiliateCookie);

  if (!affiliateCookie) {
    return;
  }

  const affiliateCookieParams = getCookieParams(affiliateCookie, [
    AffilliateCookieProperties.AffiliateId,
    AffilliateCookieProperties.ClientId,
    AffilliateCookieProperties.UtmMedium,
  ]);

  return {
    affiliateCookie,
    affiliateCookieParams,
  };
}

export function getCookieParams(
  cookie: string,
  expectedKeys: string[]
): Record<string, string | undefined> {
  const cookies: Record<string, undefined> = expectedKeys.reduce(
    (accumulator, expectedKey) => {
      accumulator[expectedKey] = undefined;
      return accumulator;
    },
    {} as Record<string, undefined>
  );

  return cookie
    .split('&')
    .map((str: string) => str.split('='))
    .reduce(
      (accumulator, pair) => {
        if (pair[0] && expectedKeys.includes(pair[0])) {
          accumulator[pair[0]] = pair[1];
        }
        return accumulator;
      },
      cookies as Record<string, string | undefined>
    );
}
